import { gql } from "@apollo/client";
import { AccountFragment } from "fragments/account";

export const DomainFragment = gql`
  fragment DomainFragment on Domain {
    id
    domainId
    domain
    description
    publicKey
    privateKey
    webhookRoute
    webhookSecret
    createdAt
    updatedAt
  }
`;

export const get = gql`
  query DomainGet($domain: String!) {
    viewer {
      id
      account {
        ...AccountFragment
        domains {
          id
          get(domain: $domain) {
            ...DomainFragment
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${DomainFragment}
`;

export const list = gql`
  query DomainList($input: ListInput) {
    viewer {
      id
      account {
        id
        domains {
          id
          list(input: $input) {
            id
            last
            items {
              id
              domain
              createdAt
            }
          }
        }
      }
    }
  }
`;




export const create = gql`
  mutation DomainNew($input: DomainInputCreate!) {
    viewer {
      account {
        domains {
          create(input: $input) {
            ...DomainFragment
          }
        }
      }
    }
  }
  ${DomainFragment}
`;



export const edit = gql`
  mutation DomainEdit(
    $domain: String!
    $input: DomainInputUpdate!
  ) {
    viewer {
      account {
        domains {
          get(domain: $domain) {
            update(input: $input) {
              ...DomainFragment
            }
          }
        }
      }
    }
  }
  ${DomainFragment}
`;


export const remove = gql`
  mutation DomainRemove($domain: String!) {
    viewer {
      account {
        domains {
          get(domain: $domain) {
            remove 
          }
        }
      }
    }
  }

`;




// Takes no argument, though every call site passes one (params, account). The
// cache eviction below is keyed on the query name alone, so there has never been
// anything to read off it — and the extra argument is harmless.
export const update = () => (cache) => {

  Object.keys(cache.data.data).forEach((key) => {
    if (key.includes(`domain/queries`)) {
      cache.data.delete(key);
    }
  });
};
